import { Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'htx-stepper-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stepper-page.component.html',
  styleUrl: './stepper-page.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class StepperPageComponent {
  animate = input<boolean>(true);
}
